import { toast } from 'components/common/Toast/Toast';
import i18n from '../i18n';
export function failOnError(response) {
    if (!response.ok) {
        throw new Error(`HTTP ${response.status} ${response.statusText || 'Error'}`);
    }
    return response;
}
export function toastOnError(response) {
    try {
        return failOnError(response);
    }
    catch (e) {
        toast('error', `${i18n.t('unexpected_error')} ${new URL(response.url).pathname}`, [e.message]);
        throw e;
    }
}
